<template>
    <div v-if="field">
        <b-input-group>
            <img :src="content.localURL" width="250px" v-if="store.getters.isRunModePlatform && content != ''"/>
            <img :src="preview" width="250px" v-else/>

            <b-form-invalid-feedback :id="field.key" style="display:block">
            {{ errors[0] || null }}
            </b-form-invalid-feedback>
         </b-input-group>

         <b-input-group v-if="!this.field.protected">
            <b-dropdown id="ddown1" text="Source" class="m-2">
                <b-dropdown-item @click="chooseFrom('library')" v-if="showChooseFromLibrary">{{ translator('integrations.media.chooseFromLibrary') }}</b-dropdown-item>
                <b-dropdown-item @click="chooseFrom('device')" v-if="showChooseFromDevice">{{ translator('integrations.media.chooseFromDevice') }}</b-dropdown-item>
                <b-dropdown-item @click="chooseFrom('external')" v-if="customData.chooseExternalSource">{{ translator('integrations.media.externalSource') }}</b-dropdown-item>
            </b-dropdown>
         </b-input-group>

      <main-dialog v-model="chooseModal.show" hide-footer hide-header size="lg">
          <Library @itemsSelected="itemSelected" v-if="this.chooseModal.type == 'library'" :filterLibraries="constraints.custom_data.image.libraries" :filterExtensions="['jpg', 'jpeg', 'png', 'gif', 'webp']" :store="store" :translator="translator"/>
          <b-form-input placeholder="https://example.image.com/nice_background.png" v-model="externalContent" v-if="this.chooseModal.type == 'external'" />
          <div v-if="this.chooseModal.type == 'device'">
            <b-form-file v-model="uploadFile" accept="image/*" @change="previewImage" />
            <b-button @click="upload" v-if="uploadFile" class="m-2"> Upload </b-button>
          </div>
      </main-dialog>
    </div>
</template>

<script>
export default {
    name: "IdentityField_ImageV2",
    components: {
        Library: () => import('@/components/integrations/protokol/media/Index')
    },
    props: {
        field: {
            type: Object
        },
        value: {
            type: String | Number,
            default: ""
        },
        store: {
            type: Object
        },
        translator: {
            type: Function
        }
    },
    data: function() {
        return {
            errors: [],
            uploadModal: {
                show: false,
                file: null
            },
            chooseModal: {
                show: false,
                file: null,
                type: ''
            },
            image: null,
            imageLoadingError: false,
            uploadFile: null,
            preview: null,
            item: null
        }
    },
    computed: {
        content: {
            get() {
                if (this.value == "" || !this.value) {
                    return {
                        localURL: "",
                        publicURL: ""
                    }
                }

                return this.value
            },

            set(val) {
                this.check(val)

                val = {
                    localURL: this.$mediaHttp.defaults.baseURL + "/media/library/" + val.library_uuid + "/get/" + val.key,
                    publicURL: val.public_url
                }

                this.$emit('input', val);
            }
        },

        externalContent: {
            get() {
                return this.content.localURL
            },

            set(val) {
                this.$emit('input', {
                    localURL: val,
                    publicURL: val
                })
            }
        },

        constraints() {
            let constr = this.field.constraints
            let { custom_data } = constr
            let { image } = custom_data
            
            if (!custom_data) {
                constr.custom_data = {
                    image: {
                        chooseFromLibrary: false,
                        chooseFromDevice: false,
                        chooseExternalSource: true,
                        libraries: [],
                        defaultLibrary: null,
                        publicUpload: false,
                        subDir: ""
                    }
                }
            }

            if (!image) {
                constr.custom_data.image = {
                    chooseFromLibrary: false,
                    chooseFromDevice: false,
                    chooseExternalSource: true,
                    libraries: [],
                    defaultLibrary: null,
                    publicUpload: false,
                    subDir: ""
                }
            }

            return constr
        },

        customData() {
            let {
                chooseFromLibrary = false,
                chooseFromDevice = false,
                chooseExternalSource = true,
                libraries = [],
                defaultLibrary = null,
                publicUpload = false,
                subDir = ""
            } = this.constraints.custom_data.image

            return {
                chooseFromLibrary: chooseFromLibrary,
                chooseFromDevice: chooseFromDevice,
                chooseExternalSource: chooseExternalSource,
                libraries: libraries,
                defaultLibrary: defaultLibrary,
                publicUpload: publicUpload,
                subDir: subDir
            }
        },

        showChooseFromLibrary() {
            return this.store.getters.isRunModePlatform && (this.customData.chooseFromLibrary && this.store.getters.isIntegrationActive('protokol-media'))
        },

        showChooseFromDevice() {
            return this.customData.chooseFromDevice && this.store.getters.isIntegrationActive('protokol-media')
        }
    },
    watch: {
        content(val) {
            this.check(val)
        }
    },
    methods: {
        check(val) {
            this.errors = []

            console.log("imagev2", val)

            if (val == "" && this.constraints.required) {
                this.errors.push(this.translator("identityField.requiredField"))
            }
                
            this.$emit("error", {field: this.field.key, error: this.errors.length > 0})
        },

        itemSelected(d) {
            let item = null
            if (d.length > 0) {
                item = d[0]
            }

            this.content = item
            this.item = item
        },


        chooseFrom(source) {
            this.chooseModal.show = true
            this.chooseModal.type = source
        },

        upload() {
            this.store.dispatch("uploadMedia", {uploadDir: this.customData.subDir, uuid: this.customData.defaultLibrary, files: [this.uploadFile], field: this.field.key, public: this.customData.publicUpload}).then(resp => {
                this.chooseModal.show = false
                let item = null
                if (resp.data.length > 0) {
                    item = resp.data[0]
                }

                this.content = item
                this.item = item
            }).catch(err => {
                this.$mainDialog.msgBoxOk(err.response.data.message)
            })
        },

        previewImage(e) {
            const file = e.target.files[0];
            this.preview = URL.createObjectURL(file);
        }

    },

    async mounted() {
        this.check(this.content)
        await this.store.dispatch('fetchIntegrations')
    }

    }
</script>